import React from 'react';

import {assertAndContinue} from 'Asserts';
import {BioentitySummary} from 'folder-items/FileConstants';
import BioentitySearchInput from 'inventory/BioentitySearchInput';
import OperatorDropdown from 'search/filters/base/OperatorDropdown';
import {ContainerContentsFilter, Operator, SearchContext} from 'search/SearchConstants';
import * as Keyboard from 'util/Keyboard';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

interface Props extends BaseFilterFormProps {
  filter: ContainerContentsFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: ContainerContentsFilter) => void;
  onEnter?: () => void;
  onRemove: () => void;
  operators: Array<Operator>;
}
export default class ContainerContentsFilterForm extends React.Component<Props> {
  handleParentBioentityChange = (bioentities: Array<BioentitySummary>): void => {
    const parentBioentityIds = bioentities.map((bioentity) => bioentity.id);
    this.props.onChangeFilter({
      ...this.props.filter,
      value: {...this.props.filter.value, contentIds: parentBioentityIds},
    });
  };

  input(): JSX.Element {
    const selectedItems = this.props.filter.value.contentIds.map((parent) => ({id: parent}));
    return (
      <BioentitySearchInput
        onChange={this.handleParentBioentityChange}
        onKeyDown={Keyboard.callOnEnter(this.props.onEnter)}
        selectedItems={selectedItems}
        shouldAllowMultiple={true}
        hideSelectedResults={true}
        context={SearchContext.LISTING}
      />
    );
  }

  render(): JSX.Element {
    const operatorDropdown = (
      <OperatorDropdown
        buttonSize={this.props.buttonSize}
        onChangeOperator={(operator: Operator) => {
          this.props.onChangeFilter({...this.props.filter, operator});
        }}
        operators={this.props.operators}
        selectedOperator={this.props.filter.operator}
      />
    );

    assertAndContinue(
      this.props.filterStyle === FilterStyle.SECONDARY,
      'Contents filter is only configured to work as a secondary filter'
    );

    const input = this.input();
    const skeletonProps = pickDefined(this.props, ...BASE_FILTER_FORM_PROP_NAMES);
    return (
      <SecondaryFilterFormSkeleton
        {...skeletonProps}
        nodeGrid={[[operatorDropdown], [input]]}
        onChangeFilterKey={this.props.onChangeFilterKey}
        selectedFilterKey={this.props.selectedFilterKey}
        onRemove={this.props.onRemove}
      />
    );
  }
}
